import ApiClient from './ApiClient';

// d99d Endpoints for the concurrent users feature.
class ConcurrentUsersAPI extends ApiClient {
  constructor() {
    // Will result in `/api/v1/accounts/:account_id/concurrent_users`.
    // The inherited `get()` answers with { count, limit }.
    super('concurrent_users', { accountScoped: true });
  }
}

export default new ConcurrentUsersAPI();
